import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public settings: any;
  public imageBase: string;
  
  constructor(
    private http: HttpClient,
    public appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
    this.imageBase = this.settings.apiURL;
  }

  getList(module: string) {
    const url = `${this.settings.apiURL}${module}/list`;
    return this.http.get(url).toPromise();
  }

  getBySlug(module: string, slug: string) {
    const url = `${this.settings.apiURL}${module}/list/${slug}`;
    return this.http.get(url).toPromise();
  }

  getByCategorySlugs(module: string, slugs: string) {
    const url = `${this.settings.apiURL}${module}/list?category_slug=${slugs}`;
    return this.http.get(url).toPromise();
  }

  getByBrandSlugs(module: string, slugs: string) {
    const url = `${this.settings.apiURL}${module}/list?brand_slug=${slugs}`;
    return this.http.get(url).toPromise();
  }

  getByBrandAndCategorySlugs(module: string, brandSlugs: string, categorySlugs: string) {
    const url = `${this.settings.apiURL}${module}/list?brand_slug=${brandSlugs}&category_slug=${categorySlugs}`;
    return this.http.get(url).toPromise();
  }

  getByBrandAndCategoryAndSubcategorySlugs(module: string, brandSlugs: string, categorySlugs: string, subcategorySlugs: string) {
    const url = `${this.settings.apiURL}${module}/list?brand_slug=${brandSlugs}&category_slug=${categorySlugs}&subcategory_slug=${subcategorySlugs}`;
    return this.http.get(url).toPromise();
  }

  // All products for a category slug (any brand): GET /product/list?category_slug=dairy
  // Brand + category via slugs: GET /product/list?brand_slug=areej&category_slug=juice
  // Brand + category + subcategory via slugs: GET /product/list?brand_slug=areej&category_slug=juice&subcategory_slug=orange-juice

  getById(module: string, id: number) {
    const url = `${this.settings.apiURL}${module}/detail/${id}`;
    return this.http.get(url).toPromise();
  }

  getBySlugs(module: string, slugs: string) {
    const url = `${this.settings.apiURL}${module}/detail/${slugs}`;
    return this.http.get(url).toPromise();
  }

  get(url: string) {
    return this.http.get(`${this.settings.apiURL}${url}`).toPromise();
  }

  create(module: string, data: any) {
    const url = `${this.settings.apiURL}${module}/create`;
    return this.http.post(url, data).toPromise();
  }

  update(module: string, id: number, data: any) {
    const url = `${this.settings.apiURL}${module}/update/${id}`;
    return this.http.post(url, data).toPromise();
  }

  status(module: string, id: number, data: any) {
    const url = `${this.settings.apiURL}${module}/status/${id}`;
    return this.http.post(url, data).toPromise();
  }

  delete(module: string, id: number, data: any) {
    const url = `${this.settings.apiURL}${module}/delete/${id}`;
    return this.http.post(url, data).toPromise();
  }

  details(module: string, id: number) {
    const url = `${this.settings.apiURL}${module}/detail/${id}`;
    return this.http.get(url).toPromise();
  }
}
